import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IFindingAndRecommendationDetails } from "../../../api/IFindingAndRecommendation";
import { ISiteVisit } from "../../../api/ISiteVisit";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { IRequestForInformation } from "../../../api/RequestForInformation";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  findingAndRecommendation: IFindingAndRecommendationDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  findingAndRecommendation,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${findingAndRecommendation.profileNo}`}
        >
          {licenceProfile.organisation} - {findingAndRecommendation.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${findingAndRecommendation.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${findingAndRecommendation.profileNo}/compliance/sitevisit/${findingAndRecommendation.regardingobjectid}`}
        >
          {findingAndRecommendation.siteVisit?.reference}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {findingAndRecommendation.reference}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
